var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { NOOP_QUERY } from "../constants";
import { entityFieldFormQueryFragment } from "../utils/entity-field-form-query-fragment";
import { pickBy } from "lodash";
import { graphql } from "@shapeable/graphql";
import { ginni } from "@shapeable/utils";
import { useEntityTypeDefinitionsQuery } from "./use-entity-type-definitions-query";
export var useEntityFormQuery = function (_a) {
  // 1. get the entity type definitions needed
  var e_1, _b;
  var entityTypeName = _a.entityTypeName,
    type = _a.type,
    id = _a.id,
    _c = _a.fields,
    fields = _c === void 0 ? [] : _c;
  var entityTypeNames = [entityTypeName];
  var otherEntityTypeNames = [];
  try {
    // Partial<Record<EntityTypeName, EntityTypeDefinition>> = {};
    for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
      var fieldDefn = fields_1_1.value;
      if (fieldDefn.entityTypeName) {
        // if the field definition itself has an entity type name, we'll need definitions for those (selects, junctions, etc)
        otherEntityTypeNames.push(fieldDefn.entityTypeName);
        entityTypeNames.push(fieldDefn.entityTypeName);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (fields_1_1 && !fields_1_1.done && (_b = fields_1.return)) _b.call(fields_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  var entityTypeDefinitionResult = useEntityTypeDefinitionsQuery(entityTypeNames);
  // console.log("ENTITY TYPE DEFINITION RESULT", entityTypeDefinitionResult);
  var entityTypeDefinition = entityTypeDefinitionResult.entityTypeDefinitions[entityTypeName];
  var oneName = entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.oneName;
  var supportingEntityTypeDefinitions = pickBy(entityTypeDefinitionResult.entityTypeDefinitions, function (defn) {
    return !!otherEntityTypeNames.includes(defn.name);
  });
  // we only need to load existing fields if this is an update, otherwise just NOOP it.
  var shouldFetchRecord = type === 'Update' && oneName;
  // changed this to be a cache-and-network fetch policy, so that we can get the data from the cache if available, and then update it with the network request
  // experienced mind-bending cache issues with cache-first, so hopefully this is suitable?
  var fetchPolicy = shouldFetchRecord ? 'cache-and-network' : 'cache-only';
  // for junction fields, we not only need the field values for those records, but also the field values for each linked entity against them
  var linkedJunctionFields = fields.filter(function (fieldDefn) {
    return fieldDefn.formFieldType === 'linkedJunction';
  });
  var junctionFragments = linkedJunctionFields.reduce(function (acc, junctionFieldDefn) {
    var junctionEntityDefinition = supportingEntityTypeDefinitions[junctionFieldDefn.entityTypeName];
    var fragment = graphql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", " { \n        ", "\n      }\n    "], ["\n      ", " { \n        ", "\n      }\n    "])), junctionFieldDefn.name, junctionEntityDefinition ? junctionEntityDefinition.formFields.map(function (fieldDefn) {
      if (fieldDefn.formFieldType === 'linked' || fieldDefn.formFieldType === 'linkedMultiple') {
        return graphql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " { ...EntityValueFields }"], ["", " { ...EntityValueFields }"])), fieldDefn.name);
      }
      return entityFieldFormQueryFragment(fieldDefn);
    }).join('\n') : ' ');
    acc.push(fragment);
    return acc;
  }, []).join('\n');
  var QUERY = oneName && graphql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    query EntityFormQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        name\n        ", "\n        ", "\n      }\n    }\n  "], ["\n    query EntityFormQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        name\n        ", "\n        ", "\n      }\n    }\n  "])), oneName, fields.map(function (fieldDefn) {
    return entityFieldFormQueryFragment(fieldDefn);
  }).join('\n'), junctionFragments);
  var _d = __read(useLazyQuery(shouldFetchRecord ? gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), QUERY) : gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), NOOP_QUERY), {
      fetchPolicy: fetchPolicy,
      variables: {
        id: id
      }
    }), 2),
    fetch = _d[0],
    _e = _d[1],
    data = _e.data,
    loading = _e.loading,
    error = _e.error;
  // 2. Fetch the data once we have enough info
  React.useEffect(function () {
    if (shouldFetchRecord) {
      fetch();
    }
  }, [shouldFetchRecord]);
  ginni.verbose.log("useEntityFormQuery QUERY DATA", data);
  return {
    data: !shouldFetchRecord ? null : (data === null || data === void 0 ? void 0 : data[oneName]) || null,
    supportingEntityTypeDefinitions: supportingEntityTypeDefinitions,
    entityTypeDefinition: entityTypeDefinition,
    loading: loading || entityTypeDefinitionResult.loading,
    error: error
  };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;